module.exports = __webpack_public_path__ + "img/menu-icon.f72e4413.png";